import { PublicClientApplication } from "@azure/msal-browser";
import { getLoginRequest, getMsalConfig } from "../../../../authConfig";

export const msalInstance = new PublicClientApplication(getMsalConfig());

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

export const getAccessToken = async (): Promise<string | null> => {
    const account = msalInstance.getActiveAccount();
    if (!account) return null;

    const response = await msalInstance.acquireTokenSilent({
        ...getLoginRequest(),
        account,
    });
    return response.accessToken;
};
